import {Badge} from '@/components/ui/badge/Badge'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledDetailsInformationWarningsBannerWrapper = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 4}px;
    `
)

export const StyledDetailsInformationWarningsBannerBadge = styled(Badge)(
    ({theme: {palette}}) => css`
        & svg {
            fill: ${palette.orange['500']};
        }
    `
)
